import * as React from 'react';

import { createIcon } from '../Icon';
export const Link2Icon = createIcon(
  <React.Fragment>
    <path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3" />
    <line x1={8} x2={16} y1={12} y2={12} />
  </React.Fragment>,
  'Link2Icon'
);
